import React from "react";
import {
  BooleanField,
  Datagrid,
  DateField,
  DeleteButton,
  FunctionField,
  Link,
  Pagination,
  ReferenceManyField,
  TextField,
  useGetManyReference,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { Typography } from "@mui/material";

const GetInvitations = ({ reference = "onpoint_extraction_software_invitation" }) => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const { data, isLoading } = useGetManyReference(reference, {
    target: 'master_customer_id',
    id: record?.id,
    pagination: { page: 1, perPage: 10 },
    sort: { field: 'id', order: 'DESC' },
  });

  if (isLoading) return null;

  if (!data || data.length === 0) {
    return <Typography sx={{ m: 2 }}>No OnPoint invitations found</Typography>;
  }

  return (
    <ReferenceManyField
      fullWidth
      label="Invitations"
      reference={reference}
      target="master_customer_id"
      source="id"
      perPage={10}
      sort={{ field: "id", order: "DESC" }}
      pagination={<Pagination />}
    >
      <Datagrid>
        <TextField source="id" />
        <DateField
          source="date_added"
        />
        <TextField source="added_by" />
        <FunctionField label="Invite Link" render={record => (
          <Link to={`/extraction_software_registration?extraction_software_registration_token=${record.extraction_software_registration_token}`} style={{ color: 'grey' }}>Invite</Link>
        )} />
        <TextField source="status" />
        <TextField source="invitation_email_send_to" />
        <BooleanField source="accepted_center_store_participation" />
        <BooleanField source="interested_in_patron_points_tobacco" />
        <BooleanField source="accepted_eula" />
        <DateField
          source="registration_completed_date"
        />
        <DeleteButton redirect={false} mutationMode="pessimistic" mutationOptions={{ onSuccess: () => refresh() }} />
      </Datagrid>
    </ReferenceManyField>
  );
};

export default GetInvitations;
